/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import ArrowButton from '../../../common/button-arrow';
import { checkPermission } from '../../../common/guards/can';
import t from '../../../../data/translations';

class FurtherInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true,
    };
  }

  toggleFurtherInformation = () => {
    this.setState({ open: !this.state.open });
  };

  furtherInformationIsVisible = () => {
    const { current_user } = this.props;

    if (current_user.attributes['user-group'] !== 'staff') {
      return true;
    }
    return checkPermission('view', 'objective_performance');
  }

  incentiveIsBaseTarget = () => {
    const { data } = this.props;

    return data.kind === 'base_target';
  }

  render() {
    const { data } = this.props;
    const { open } = this.state;

    return (
      <div className="further-information">
        <div className="further-information-head">
          <Row>
            <Col lg={6}>
              {this.furtherInformationIsVisible() && (
                <div onClick={this.toggleFurtherInformation}>
                  <span className={`glyphicon glyphicon-menu-${open ? 'up' : 'down'}`} aria-hidden="true"></span>
                  <span className="further-information-title">Further information</span>
                </div>
              )}
            </Col>
            <Col lg={6}>
              {data.bonus_points_enabled && data.bonus_link && (
                <ArrowButton
                  color={data.locked ? 'red' : 'yellow'}
                  arrow
                  onClick={() => {
                    window.open(data.bonus_link, '_blank');
                  }}
                >
                  ABOUT THE INCENTIVE
                </ArrowButton>
              )}
            </Col>
          </Row>
        </div>
        {open && (
          <div className="further-information-body">
            <div className="separator sell-it" />
            <div className="further-information-section">
              <div className="no-padding">
                <div className="points-per-pack">
                  <div className="points-per-pack-pre">
                    <div>
                      {this.incentiveIsBaseTarget() ? `${t('pointsPerPack.up')} 1` : t('pointsPerPack.up')}
                    </div>
                    <strong>{data.points_to_target}</strong>
                  </div>
                  {this.incentiveIsBaseTarget() && (
                    <div className="points-per-pack-pre">
                      <div>
                        {t('pointsPerPack.up')} 2
                      </div>
                      <strong>{data.points_to_target_2}</strong>
                    </div>
                  )}
                  <div className="points-per-pack-after">
                    <div>
                      {this.incentiveIsBaseTarget() ? `${t('pointsPerPack.post')} 2` : t('pointsPerPack.over')}
                    </div>
                    <strong>{data.points_after_target}</strong>
                  </div>
                </div>
              </div>
              <div className="no-padding">
                <div className="point-reward-summary">
                  {data.bonus_points_enabled && data.bonus_points_display && (
                    <div className="points-bonus">
                      <h2>Bonus</h2>
                      <strong>
                        {(data.points_earned && data.bonus_points_awarded.toLocaleString('en', { useGrouping: true })) || 0}
                      </strong>
                    </div>
                  )}
                  <div className="points-earned">
                    <h2>Points Earned</h2>
                    <strong>{(data.points_earned && data.points_earned.toLocaleString('en', { useGrouping: true })) || 0}</strong>
                  </div>
                  <div className="points-awarded">
                    <h2>Points Awarded</h2>
                    <strong>{(data.points_awarded && data.points_awarded.toLocaleString('en', { useGrouping: true })) || 0}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  current_user: state.viewConfig.profile
});

export default connect(mapStateToProps)(FurtherInformation);



// WEBPACK FOOTER //
// ./src/components/store-performance/user-performances/subcomponents/further-information.jsx